import { Progress } from "@/components/ui/progress";
import { BarChart3 } from "lucide-react";

export default function WorkflowOverview({ orders }) {
  // Count orders by status
  const statusCounts = {};
  const allStatuses = new Set();

  orders.forEach((order) => {
    allStatuses.add(order.current_status);
    statusCounts[order.current_status] = (statusCounts[order.current_status] || 0) + 1;
  });

  const statusArray = Array.from(allStatuses).map((status) => ({
    status,
    count: statusCounts[status],
    percentage: (statusCounts[status] / orders.length) * 100,
  }));

  // Sort by count descending
  statusArray.sort((a, b) => b.count - a.count);

  const getStatusColor = (status) => {
    if (status === "Delivered") return "bg-green-500";
    if (status === "Design" || status === "Approved") return "bg-blue-500";
    if (status === "Pack") return "bg-purple-500";
    return "bg-amber-500";
  };

  const getStatusBadgeColor = (status) => {
    if (status === "Delivered") return "bg-green-100 text-green-800";
    if (status === "Design" || status === "Approved") return "bg-blue-100 text-blue-800";
    if (status === "Pack") return "bg-purple-100 text-purple-800";
    return "bg-amber-100 text-amber-800";
  };

  if (orders.length === 0) {
    return (
      <div className="bg-card border border-border rounded-md p-6">
        <h3 className="text-lg font-heading font-bold mb-4 flex items-center">
          <BarChart3 className="h-5 w-5 mr-2 text-primary" />
          Workflow Overview
        </h3>
        <p className="text-sm text-muted-foreground text-center py-8">No workflow data</p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-md p-6">
      <h3 className="text-lg font-heading font-bold mb-4 flex items-center" data-testid="workflow-overview-title">
        <BarChart3 className="h-5 w-5 mr-2 text-primary" />
        Workflow Overview
      </h3>
      <div className="space-y-4">
        {statusArray.map(({ status, count, percentage }) => (
          <div key={status} data-testid={`workflow-status-${status.toLowerCase().replace(/\s+/g, '-')}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <span className={`px-2 py-1 rounded text-xs font-medium ${getStatusBadgeColor(status)}`}>
                  {status}
                </span>
                <span className="text-sm font-medium">{count}</span>
              </div>
              <span className="text-xs text-muted-foreground">{percentage.toFixed(0)}%</span>
            </div>
            <div className="relative h-2 bg-secondary rounded-full overflow-hidden">
              <div
                className={`absolute top-0 left-0 h-full transition-all duration-300 ${getStatusColor(status)}`}
                style={{ width: `${percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
